import { render, staticRenderFns } from "./ChartConfigurationPieFamilySeries.vue?vue&type=template&id=50be9b52&"
import script from "./ChartConfigurationPieFamilySeries.vue?vue&type=script&lang=ts&"
export * from "./ChartConfigurationPieFamilySeries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports